import React from "react";
import { Navigate, useLocation } from "react-router-dom";

import { resolveRouteStateReturnTo } from "../lib/appHeaderRoutes";

export default function RequestExecutiveMemosPage() {
  const location = useLocation();
  const returnTo = resolveRouteStateReturnTo(location.state, "/home");

  return (
    <Navigate
      to="/executive-memos?create=1"
      replace
      state={{ returnTo }}
    />
  );
}
